import apiAxiosClient from './apiAxiosClient';

const moneyApi = {
    getAll(params) {
        const url = '/api/money/all';
        return apiAxiosClient.post(url, params);
    },
    getById(params) {
        const url = '/api/money/one';
        return apiAxiosClient.post(url, params);
    },
    insert(params) {
        const url = '/api/money/insert';
        return apiAxiosClient.post(url, params);
    },
    edit(params) {
        const url = '/api/money/update';
        return apiAxiosClient.post(url, params);
    },
    delete(params) {
        const url = '/api/money/delete';
        return apiAxiosClient.post(url, params);
    },
};

export default moneyApi;
